"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YAxis = exports.XAxis = undefined;

var _XAxis = require("./XAxis");

var _XAxis2 = _interopRequireDefault(_XAxis);

var _YAxis = require("./YAxis");

var _YAxis2 = _interopRequireDefault(_YAxis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.XAxis = _XAxis2.default;
exports.YAxis = _YAxis2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/axes/index.js
// module id = 866
// module chunks = 0